
import React from "react";
import { Modal, ModalOverlay, Text, ModalContent, ModalCloseButton, ModalBody } from "@chakra-ui/react";


export const FullForecastModal = (props) => {
    const {isOpen, onClose, zoneForecasts } = props;

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent
                style={{
                    marginLeft: 15,
                    marginRight: 15,
                }}
            >
                <ModalCloseButton />
                <ModalBody py={6}>
                    {zoneForecasts?.length > 0 && zoneForecasts.map((forecast) => (
                        <Text key={forecast.zone} pb={4} mb={4} style={{ whiteSpace: 'pre-wrap' }} borderBottomColor="gray.300" borderBottomStyle="solid" borderBottomWidth={1}>
                            {forecast.preamble}
                            {forecast.shortSynopsis}
                        </Text>
                    ))}
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};
